import React, { useEffect } from 'react';
import axios from 'axios';

import './Home.css'

import Banner from '../../Components/Banner/Banner'
import HAboutSection from '../../Components/HAboutSection/HAboutSection'
import HEventsSection from '../../Components/HEventsSection/HEventsSection'
import HProjectSection from '../../Components/HProjectSection/HProjectSection';
import HResearchSection from '../../Components/HResearchSection/HResearchSection';

const Home = () => {

    return (
        <div>
            <Banner />
            <div className='greenBottomBorder'>
                <div className="container text-center mt-5 mb-5" >
                    {/* <h2 className="display-6 fw-bold">Welcome to CoE SPA New Delhi</h2> */}
                </div>
            </div>
            <HAboutSection />
            <HProjectSection />
            <HResearchSection />
            <HEventsSection />
        </div>
    );
};

export default Home;
